<template>
  <v-flex
    xs12
    sm6
    md6>
    <div id="repaymentsStatusFilter">
      <v-btn
        :class="{ secondary: repaymentsSelection === 'new' }"
        selection="unpaid"
        color="#3357A0"
        @click="$emit('filterRepayments','new')">{{ 'krita.reports.repayments.filter.new' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: repaymentsSelection === 'paid' }"
        selection="pastDueDate"
        color="#3357A0"
        @click="$emit('filterRepayments','paid')">{{ 'krita.reports.repayments.filter.paid' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: repaymentsSelection === 'canceled' }"
        selection="repaid"
        color="#3357A0"
        @click="$emit('filterRepayments','canceled')">{{ 'krita.reports.repayments.filter.canceled' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: repaymentsSelection === 'all' }"
        selection="all"
        color="#3357A0"
        @click="$emit('filterRepayments','all')">{{ 'krita.reports.repayments.filter.all' | translate }}</v-btn>
    </div>
    <div id="repaymentsTypeFilter">
      <v-btn
        :class="{ secondary: repaymentsTypeSelection === 'legal' }"
        selection="pastDueDate"
        color="#3357A0"
        @click="$emit('filterRepaymentsType','legal')">{{ 'krita.reports.repayments.filter.legal' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: repaymentsTypeSelection === 'repayment' }"
        selection="repaid"
        color="#3357A0"
        @click="$emit('filterRepaymentsType','repayment')">{{ 'krita.reports.repayments.filter.repayment' | translate }}</v-btn>
      <v-btn
        :class="{ secondary: repaymentsTypeSelection === 'all' }"
        selection="all"
        color="#3357A0"
        @click="$emit('filterRepaymentsType','all')">{{ 'krita.reports.repayments.filter.all' | translate }}</v-btn>
    </div>
  </v-flex>
</template>

<script>
    export default {
        name: "RepaymentsControllers",
        props: ['repaymentsSelection','repaymentsTypeSelection'],
    }
</script>

<style scoped>

</style>
